import { Do, timer } from '../../universal';
import { _ } from '../lib';
import { unmountReactOnElement } from './component-react';
import { Bindings } from './ui5';
export const newSystemFlyout = (p) => {
    const flyout = new NewSystemFlyoutInstance({
        size: p.size,
        callback: p.callback,
        coords: p.coords,
        nopadding: p.nopadding,
        cl: p.cl,
        anchorRight: p.anchorRight,
        closeCallback: p.closeCallback,
    });
    flyout.Build();
    return flyout;
};
export class NewSystemFlyoutInstance {
    params;
    padding;
    Element;
    Lock;
    constructor(param) {
        Bindings(this, [this.Close]);
        this.params = {
            size: param.size ?? [null, null],
            coords: param.coords ?? [null, null],
            callback: param.callback ?? _.noop,
            nopadding: param.nopadding ?? false,
            cl: param.cl ?? '',
            anchorRight: param.anchorRight ?? false,
            closeCallback: param.closeCallback ?? _.noop,
        };
        this.padding = Do(() => {
            if (this.params.nopadding) {
                return {
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                };
            }
            return {
                top: 10,
                left: 5,
                right: 5,
                bottom: 20,
            };
        });
    }
    getSize() {
        let [w, h] = this.params.size;
        if (w == null) {
            w = 640;
        }
        if (h == null) {
            h = 99999;
        }
        const maxWidth = window.innerWidth - (this.padding.left + this.padding.right);
        const maxHeight = window.innerHeight - (this.padding.top + this.padding.bottom);
        if (w > maxWidth) {
            w = maxWidth;
        }
        if (h > maxHeight) {
            h = maxHeight;
        }
        return [Math.floor(w), Math.floor(h)];
    }
    getCoords(size) {
        if (size == null) {
            size = this.getSize();
        }
        let [x, y] = this.params.coords;
        if (x == null) {
            x = (window.innerWidth - size[0]) / 2;
        }
        if (y == null) {
            y = (window.innerHeight - size[1]) / 4;
        }
        const maxLeft = window.innerWidth - size[0] - this.padding.right;
        const maxTop = window.innerHeight - size[1] - this.padding.bottom;
        if (x < this.padding.left) {
            x = this.padding.left;
        }
        if (y < this.padding.top) {
            y = this.padding.top;
        }
        if (x > maxLeft) {
            x = maxLeft;
        }
        if (y > maxTop) {
            y = maxTop;
        }
        return [x, y].map(Math.floor);
    }
    getStyles() {
        const size = this.getSize();
        const coords = this.getCoords(size);
        const transform_offset = coords[1] + size[1] + 40;
        return {
            width: `${size[0]}px`,
            height: `${size[1]}px`,
            left: !this.params.anchorRight ? `${coords[0]}px` : undefined,
            right: this.params.anchorRight
                ? `${window.innerWidth - coords[0] - size[0]}px`
                : undefined,
            top: `${coords[1]}px`,
            transform: `translateY(-${transform_offset}px`,
        };
    }
    Build() {
        this.Element = Do(() => {
            const flyout = document.createElement('div');
            if (this.params.cl != null && this.params.cl) {
                flyout.classList.add(this.params.cl);
            }
            flyout.classList.add('to_floater');
            flyout.classList.add('newFlyout');
            flyout.appendChild(Do(() => {
                const el = document.createElement('div');
                el.classList.add('floater_body');
                return el;
            }));
            _.forEach(this.getStyles(), (v, k) => {
                flyout.style[k] = v;
            });
            return flyout;
        });
        this.Lock = Do(() => {
            const el = document.createElement('div');
            el.classList.add('toPageLockNew');
            el.classList.add('inactive');
            el.addEventListener('click', () => {
                this.Close();
            });
            return el;
        });
        document.body.appendChild(this.Lock);
        document.body.appendChild(this.Element);
        timer(10, () => {
            this.Lock.classList.remove('inactive');
            this.Element.style.transform = 'translateY(0)';
            timer(170, () => {
                this.params.callback(this);
            });
        });
    }
    Close() {
        if (this.Element != null && this.Element.style != null) {
            this.Element.style.transform = this.getStyles().transform;
        }
        this.Lock?.classList?.add('inactive');
        timer(170, () => {
            try {
                unmountReactOnElement(this.Element);
            }
            catch (error) { }
            this.Lock?.remove();
            this.Element?.remove();
            this.params.closeCallback();
        });
    }
    ChangeSize(sizeParams) {
        const { width, height, top, left } = sizeParams;
        this.params.size = [width ?? this.params.size[0], height ?? this.params.size[1]];
        this.params.coords = [left ?? this.params.coords[0], top ?? this.params.coords[1]];
        const readOnlyProps = ['length', 'parentRule', 'cssText', 'transform'];
        const styles = this.getStyles();
        if (this.Element?.style) {
            Object.entries(styles)
                .filter(([key]) => !readOnlyProps.includes(key))
                .forEach(([key, value]) => {
                ;
                this.Element.style[key] = value;
            });
        }
    }
}
//# sourceMappingURL=flyouts.js.map